
/* eslint-disable react/jsx-key */
import "./styles.css"

import { saveAs } from "file-saver"
import { t } from "i18next"
import React, {
    useEffect,
    useImperativeHandle,
    useState
} from "react"
import { downloadExcel } from "react-export-table-to-excel"
import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"
import {
    useAsyncDebounce,
    useFilters,
    useGlobalFilter,
    usePagination,
    useRowSelect,
    useSortBy,
    useTable
} from "react-table"
import * as XLSX from "xlsx"

import closeIcon from "../../../assets/common/close.svg"
import downloadIcon from "../../../assets/Hub_Icons/download.svg"
import editIcon from "../../../assets/Hub_Icons/edit.svg"
import filterIcon from "../../../assets/Hub_Icons/filter.svg"
import searchIcon from "../../../assets/Hub_Icons/search.svg"
import sortIcon from "../../../assets/Hub_Icons/sort.svg"
import { SelectDropdown } from "../../../pages/pricing/SelectComponent"
import { formatPrice } from "../../../utils/utils.js"
import LanguageSelector from "../../LanguageSelector"
import ToggleButton from "../../Tables/ToggleButton"
import DropDownButton from "../Form/DropdownButton/index.js"
import Dropdown from "../Form/DropdownWithSetValueSupport"
import Language from "../Language"
import Loader from "../Loader/loader"

export const GlobalFilter = ({
    globalFilter,
    setGlobalFilter,
    isCustomSearch,
    onCustomSearch,
    customsearchtext,
    searchWrapperClass

}) => {
    const [searchtxt, setSearchtxt] = useState(globalFilter)

    const onChange = useAsyncDebounce((searchtxt) => {
        if (isCustomSearch) {
            if (customsearchtext?.trim() != "" && searchtxt?.trim() == "") {
                onCustomSearch(searchtxt)
            }
        } else {
            setGlobalFilter(searchtxt || undefined)
        }
    }, 200)

    useEffect(() => {
        if (isCustomSearch && customsearchtext?.trim() != "") {
            setSearchtxt(customsearchtext)
        }
    }, [])


    return (
        <div className="relative">
            <input
                type="Search"
                className={ `${searchWrapperClass || ""} border-lightGray border 
                    rounded-[57px] h-9 px-4 pr-12 outline-0 placeholder-secondary-50 
                    fontSize-sm focus:outline-none focus:ring-0 focus:border-primary-100 
                    focus:bg-lightSkyblue hover:border-primary-100` }
                placeholder={ t("common.search") }
                value={ searchtxt || "" }
                onChange={ (e) => {
                    setSearchtxt(e.target.value)
                    onChange(e.target.value)
                } }
                onKeyDown={ (e) => {
                    if (e.key === "Enter") {
                        if (isCustomSearch) {
                            onCustomSearch(searchtxt || "")
                        } else {
                            setGlobalFilter(searchtxt || undefined)
                        }
                    }
                } }
            />
            <button
                type="submit"
                className="absolute right-4 h-9 top-0 flex items-center justify-center"
                onClick={ () =>
                    isCustomSearch && searchtxt
                        ? onCustomSearch(searchtxt)
                        : setGlobalFilter(searchtxt)
                }
            >
                <img alt="search" src={ searchIcon } className="" height={ "16px" } width={ "16px" } />
            </button>
        </div>
    )
}

const ReactEditableTable = ({
    columns,
    data,
    updateAPI,
    title,
    translateFeature,
    globalLanguageChange,
    downloadFeature,
    downloadData,
    addNewFeature,
    customButtonFeature,
    customButton,
    filterFeature,
    onHandleToogleClick,
    isStickyColumns,
    setCurrentLanguages,
    isJsondownload,
    getDownloadData,
    isDeleteRow,
    isCountryHubAssociation,
    status,
    loader,
    disableSearch,
    sortFeature,
    handleFilterClick,
    permissionDetails,
    isButonURL,
    isFilteredValue,
    languageChangeHandler,
    isCustomLanguageSelector,
    renderKey,
    isDropdownButton,
    dropdownMenus,
    selectedData,
    setSelectedData,
    onHandleChange,
    resetSelectedData,
    isCustomSearch,
    onCustomSearch,
    customsearchtext,
    showConvertCurrency,
    convertCurrency,
    ...props
}) => {
    const [editableRowIndex, setEditableRowIndex] = useState(null)
    const [editableRowId, setEditableRowId] = useState(null)
    const { t } = useTranslation()
    const [sortValue, setSortValue] = useState("")    
    // For this example, we're using pagination to illustrate how to stop
    // the current page from resetting when our data changes
    // Otherwise, nothing is different here.
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        setGlobalFilter,
        state,
        rows,
        selectedFlatRows
    } = useTable(
        {
            columns,
            data,
            //defaultColumn,
            // use the skipPageReset option to disable page resetting temporarily
            //autoResetPage: !skipPageReset,
            // updateMyData isn't part of the API, but
            // anything we put into these options will
            // automatically be available on the instance.
            // That way we can call this function from our
            // cell renderer!
            //updateMyData,
            updateAPI,
            editableRowIndex,
            setEditableRowIndex,
            initialState: { 
                pageIndex: 0
            }
        },
        useFilters,
        useGlobalFilter,
        useSortBy,
        usePagination,
        useRowSelect,
        (hooks) => {
            if (permissionDetails?._update || permissionDetails?._delete) {
                hooks.allColumns.push((columns) => [
                    ...columns,
                    // pass edit hook
                    {
                        accessor: "Action",
                        id: "edit",
                        Header: t("Pricing.action"),
                        fixed: "right",
                        disableSortBy: true,
                        type: "action",
                        styles: "border-l border-secondary-300 text-right"
                    }
                ])
            }
        }
    )
    const onUpdate = () => {
        updateAPI(selectedData)
        setEditableRowId(null)
    }

    const onClose = () => {
        setEditableRowId(null)
        resetSelectedData()
    }

    const exportJSONToExcel = async () => {
        let result = await getDownloadData()
        const worksheet = XLSX.utils.json_to_sheet(
            isCountryHubAssociation ? result.data : result
        )
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, downloadData.sheet)
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array"
        })
        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
        })
        saveAs(blob, downloadData.fileName)
    }

    const handleDownloadExcel = () => {
        if (isJsondownload) {
            exportJSONToExcel()
        } else {
            downloadExcel({
                fileName: downloadData.fileName,
                sheet: downloadData.sheet,
                tablePayload: {
                    header: downloadData.header,
                    body: downloadData.body
                }
            })
        }
    }
    const countryDetail = sessionStorage?.getItem("countryDetails")
    const parsedCountryDetail = countryDetail && JSON.parse(countryDetail)

    useEffect(() => {
        if (props.setShowPagination) {
            if (
                state.globalFilter !== "" &&
            state.globalFilter !== undefined &&
            rows.length < 10
            ) {
                props.setShowPagination(false)
            } else {
                props.setShowPagination(true)
            }
        }
    }, [rows])
    
    useImperativeHandle(
        props?.selectedRows,
        () => ({
            getSelectedRows: () => selectedFlatRows
        }),
        [selectedFlatRows]
    )

    // Render the UI for your table
    return (
        <>
            <div className="flex justify-between gap-4 items-center px-4">
                <h3 className="text-md font-black text-primary-50 flex-[1_0_0]">{ `${t(title)}` }</h3>
                <div className="flex gap-4">
                    { !disableSearch && (
                        <GlobalFilter
                            globalFilter={ state.globalFilter }
                            setGlobalFilter={ setGlobalFilter }
                            isCustomSearch={ isCustomSearch }
                            onCustomSearch={ onCustomSearch }
                            customsearchtext={ customsearchtext }
                            searchWrapperClass={ props?.searchWrapperClass }
                        />
                    ) }
                    { translateFeature && (
                        <div className="relative w-[152px]">
                            { !isCustomLanguageSelector && <><label className="text-xs text-secondary-200 
                            absolute bg-white z-[1] top-[-8px] left-[10px]">
                                { t("common.selectLanguage") }
                            </label><LanguageSelector setCurrentLanguages={ setCurrentLanguages } currentVal={ 12 } />
                            </> }
                            { isCustomLanguageSelector && <Language changeHandler={ languageChangeHandler } 
                                globalLanguageChange={ globalLanguageChange } renderKey={ renderKey } /> }
                        </div>
                    ) }
                    { downloadFeature && (
                        <div className="flex-auto">
                            <button onClick={ handleDownloadExcel } type="button">
                                <img
                                    alt="Download"
                                    src={ downloadIcon }
                                    className="relative  fill-current rounded-full border 
                                    border-primary-100 hover:border-0 hover:bg-primary-150 p-2"
                                    height={ "36px" }
                                    width={ "36px" }
                                    title="Download"
                                />
                            </button>
                        </div>
                    ) }
                    { filterFeature && (
                        <div className="flex-auto relative">
                            <button type="button" onClick={ handleFilterClick }>
                                <img
                                    alt={ t("common.filter") }
                                    src={ filterIcon }
                                    className="relative  fill-current rounded-full border 
                                    border-primary-100 hover:border-0 hover:bg-primary-150 p-2"
                                    height={ "36px" }
                                    width={ "36px" }
                                    title="Filter"
                                />
                            </button>
                            { isFilteredValue && <span className="absolute w-[14px] h-[14px] 
                            shrink-0 border rounded-full background bg-tertiary-500 right-[0px] 
                            top-[4px] solid border-white -mt-2"></span> }
                        </div>
                    ) }
                    { addNewFeature && permissionDetails?._write && (
                        <div className="flex-auto">
                            <button
                                type="button"
                                onClick={ () => props.onAddNew() }
                                className="rounded-full w-full  bg-primary-100 text-white font-bold text-sm  
                                hover:bg-primary-150 hover:text-primary-50 h-9 px-4"
                            >
                                { isDeleteRow
                                    ? `+ ${t(`${props.buttonTitle}`)}`
                                    : isButonURL ? props.buttonTitle : `+ ${t("common.add")} ${t(title)}` }
                            </button>
                        </div>
                    ) }
                    {
                        showConvertCurrency && (
                            <div className="flex-auto">
                                <button
                                    type="button"
                                    onClick={ () => convertCurrency() }
                                    className="rounded-full w-full  bg-primary-100 text-white font-bold text-sm 
                                     hover:bg-primary-150 hover:text-primary-50 h-9 px-4"
                                >
                                    { t("common.covertToEur") }
                                </button>
                            </div>
                        )
                    }
                    { isDropdownButton && dropdownMenus && permissionDetails?._write && (
                        <div className="flex-auto">
                            <DropDownButton
                                label={ props?.buttonTitle }
                                buttonWrapperClass={ props?.buttonliWrapper }
                                subMenus={ dropdownMenus }
                            />
                        </div>
                    )
                    }
                    { sortFeature && (
                        <div className="flex w-full gap-4 min-w-40">
                            <SelectDropdown
                                options={ props.sortOptions }
                                placeholder={ t("common.sortBy") }
                                className="border-lightGray border rounded-[57px] h-9 px-4 pr-12 outline-0 
                                placeholder-secondary-50 fontSize-sm"
                                onHandleChange={ (e) => {
                                    setSortValue(e.value)
                                    props.onSelectSort(e.value)
                                } }
                                value={ sortValue }
                            />
                        </div>
                    ) }
                    { customButtonFeature && (
                        <div className="flex w-[240px]">
                            { customButton?.type == "Dropdown" && (
                                <Dropdown
                                    className={ "h-[35px] w-[98%] mt-0 mr-0" }
                                    value=""
                                    placeholder={ t("lms.trainingCompletionStatus") }
                                    options={ customButton.options }
                                    name="status"
                                    id="status"
                                    changeHandler={ (e) => customButton?.onChange(e.value) }
                                    isMulti={ false }
                                    isNotRequired={ true }
                                />
                            ) }
                            { customButton?.type != "Dropdown" && (
                                <button
                                    type="button"
                                    onClick={ () => customButton?.onClick() }
                                    className="flex items-center gap-[4px] rounded-full w-full bg-primary-100
                                    text-white font-bold text-sm  hover:bg-primary-150 hover:text-primary-50 h-9 px-4"
                                >
                                    { `${customButton?.title}` }
                                    { customButton?.icon && (
                                        <img
                                            src={ customButton?.icon }
                                            className="w-[12px] h-[12px] flex-shrink-0"
                                            alt="calendarIcon"
                                        />
                                    ) }
                                </button>
                            ) }
                        </div>
                    ) }
                </div>
            </div>
            <div className="commonTable w-full overflow-auto">
                <table { ...getTableProps() } className="table-auto text-left w-full border-separate 
                border-spacing-0" style={ { display: "block", "overflowX": "auto" } }>
                    <thead className="bg-lightSkyblue">
                        { headerGroups.map((headerGroup, index) => (
                            <tr { ...headerGroup.getHeaderGroupProps() } key={ index } 
                                className={ index === 0 ? "table-header border-r-2 border-gray-50 border-solid" 
                                    : "sub-header" }>
                                { headerGroup.headers.map(column => (
                                    <th className={ `px-4 min-h-[40px] text-sm font-bold text-primary-50 
                                        py-[10px] ${column.fixed ? `fixed ${column.fixed} sticky border-l 
                                            border-secondary-300 text-left ` : ""} 
                                            ${column.textAlign==="right"?"!text-right":"text-left"}` }{ ...column.getHeaderProps(column.getSortByToggleProps()) }>
                                        <div className="inline-flex items-center gap-2">
                                            { column.render("Header") }
                                            <span className="shrink-0">
                                                { column.canSort &&
                                                    (column.isSorted ? (
                                                        <img
                                                            src={ sortIcon }
                                                            className="text-gray-600 h-4 w-4 fill-current"
                                                            height={ "16px" }
                                                            width={ "16px" }
                                                            alt="sort"
                                                        />
                                                    ) : (
                                                        <img
                                                            src={ sortIcon }
                                                            className="text-gray-600 h-4 w-4 fill-current"
                                                            height={ "16px" }
                                                            width={ "16px" }
                                                            alt="sort"
                                                        />
                                                    )) }
                                            </span>
                                        </div>
                                        <div
                                            className={
                                                "border-[#CED0D6] absolute top-0 h-fill-available" +
                                                (isStickyColumns === true
                                                    ? index === 0
                                                        ? " border-r right-0 "
                                                        : headerGroup.headers.length - 1 === index
                                                            ? " border-l left-0 "
                                                            : ""
                                                    : "")
                                            }
                                        ></div>
                                    </th>
                                )) }
                            </tr>
                        )) }
                    </thead>
                    { (loader || status === "pending") && <Loader loading={ true } /> }
                    { status !== "pending" && data && data?.length === 0 ? (
                        <tr role="row">
                            <td
                                colSpan={ columns.length }
                                className="text-center	pt-5 text-#34383F text-1xl font-Avenir"
                            >
                                { t("common.noRecordsMsg") }
                            </td>
                        </tr>
                    ) : (
                        <tbody { ...getTableBodyProps() } className="bg-white divide-y text-left divide-gray-200">
                            { rows.map((row, i) => {
                                prepareRow(row)
                                return (
                                    <tr { ...row.getRowProps() } className="hover:bg-gray-200 table-row">
                                        { row.cells.map((cell, index) => {
                                            const isEditable = editableRowId === row.index
                                            const isInput = cell.column.type === "input"
                                            const isBolean = cell.column.type === "bolean"
                                            return (
                                                <td { ...cell?.getCellProps() } className={ `${cell.column.styles 
                                                    ? cell.column.styles : ""} ${cell.column.type == "input" 
                                                    ? "text-center" : ""} p-4 ${cell.column.type === "dropdown" 
                                                    ? "dd" : ""} ${cell.column.fixed ? 
                                                    `fixed ${cell.column.fixed} min-w-40 sticky border-r-1 
                                                    border-gray-500 border-solid ` : ""} px-4 border-b 
                                                    border-secondary-300 text-sm text-secondary-50 py-2` }>
                                                    { isEditable && cell.column.type === "action" ?
                                                        (<div className="flex flex-row justify-end items-end">
                                                            <div>
                                                                <NavLink
                                                                    onClick={ () => onUpdate() }
                                                                    className="nav-link text-sm text-primary-100"
                                                                >
                                                                    { t("Pricing.save") }
                                                                </NavLink>

                                                            </div>
                                                            <div className="pt-0.5 pl-4">
                                                                <button onClick={ () => onClose() } 
                                                                    className="toast-close-btn h-4 w-4 ">
                                                                    <img src={ closeIcon } alt="close" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                        ) :
                                                        isEditable == false && cell?.column?.type === "action" ? <>
                                                            {

                                                                permissionDetails?._update &&
                                                                    <button className="shrink-0 p-2 rounded-full 
                                                                    hover:border-0 hover:bg-primary-150 
                                                                    transition-transform transform hover:scale-110" 
                                                                    onClick={ () => { setEditableRowId(row.index); setSelectedData({ ...row.original }) } }>
                                                                        <img src={ editIcon } alt="Edit" title="edit" 
                                                                            className="" height={ "12px" } 
                                                                            width={ "12px" } />
                                                                    </button>
                                                            }
                                                        </> :
                                                            isEditable && isInput ? (
                                                                <>
                                                                    <input
                                                                        type="text"
                                                                        defaultValue={ selectedData[cell.column.id] 
                                                                            ? "" : cell.value }
                                                                        className="w-12 p-2 border-lightGray border 
                                                                        rounded-lg w-full p-3 h-9 outline-0 
                                                                        placeholder-secondary-50 
                                                                        fontSize-sm focus:outline-none focus:ring-0 
                                                                        focus:border-primary-100 
                                                                        focus:bg-lightSkyblue hover:border-primary-100`"
                                                                        id={ `${cell.column.id}_${index}` }
                                                                        name={ cell.column.id }
                                                                        onChange={ (e) => onHandleChange(e) }
                                                                        value={ selectedData[cell.column.id] }
                                                                    />

                                                                </>
                                                            ) : isEditable && isBolean ? (
                                                                <>
                                                                    <ToggleButton
                                                                        row={ row }
                                                                        onHandleChange={ onHandleToogleClick }
                                                                        disabled={ permissionDetails?._update 
                                                                            ? false : true }
                                                                        value={ selectedData?.override }
                                                                        type="Yes"

                                                                    />
                                                                </>)
                                                                :
                                                                (
                                                                    cell.render("Cell")
                                                                ) }
                                                </td>
                                            )

                                        }) }
                                    </tr>
                                )
                            }) }
                        </tbody>
                    ) }
                </table>
            </div>
        </>
    )
}

export default ReactEditableTable
